import Backbone from 'backbone'
import template from './single-tree-selector.hbs'
import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'

/**
 * View for selecting a single item from a single tree.  It's just a tree and
 * a select button and that's it.
 */
var SingleTreeSelector = Backbone.View.extend({

	// this.options.treeId is the ID of the tree (don't name it just ID because
	// that will cause Backbone to assign a DOM ID to this.el)

	// this.options.Gardener (or this.Gardener) is the gardener to use

	// this.options.title (or this.title) is the title for the
	// dialog.  Callers must escape the title so we can support HTML in the
	// title

	// can alternatively specify this.Gardener or this.title if you prefer

	tagName: 'form',

	className: 'single-tree-selector',

	events: {
		'submit': 'select'
	},

	initialize: function(options) {
		this.options = options || {}
		this.formView = new FormView({
			el: this.el,
			guard: false,
			submit: this.submit.bind(this),
			allowCleanSubmission: !_.isNil(this.options.treeId)
		})
	},

	render: function() {
		let primaryButtonText = this.options.primaryButtonText ||
			_.result(this, 'primaryButtonText')
		var context = {
			title: this.options.title || _.result(this, 'title'),
			primaryButtonText
		}
		let itemType = this.options.itemType || _.result(this, 'itemType')
		if (itemType) {
			context.itemType = itemType.toLowerCase()
		}
		this.$el.empty().append(template(context))

		var Gardener = this.options.Gardener || this.Gardener
		this.gardener = new Gardener(_.defaults({
			id: this.options.treeId,
			finderOptions: {
				type: 'light',
				autofocus: true
			}
		}, this.options))
		let panelContent = this.$('.panel-content')
		panelContent.append(this.gardener.el)
		this.gardener.render()
		this.$('.tree-container').addClass('tree-container-light')

		// don't want to dirty the form if there isn't a valid selection
		// #48393 if invalidIds or a geographic level was specified
		if (_.isEmpty(this.options.invalidIds) && _.isNil(this.options.geographicLevel)) {
			this.listenTo(this.gardener, 'select',
				this.formView.change.bind(this.formView))
		}

		this.formView.start()
		// If there are no nodes, empty the panel completely so the empty message will appear
		this.gardener.on('rendered', () => {
			if (_.isEmpty(this.gardener.tree.nodes)) {
				panelContent.empty()
			} else {
				panelContent.addClass('tree-loaded')
			}
		})
		return this
	},

	submit: function() {
		this.trigger('select', this.gardener.tree.selected())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.gardener, this.formView], 'remove')
	}

})

export default SingleTreeSelector

SingleTreeSelector.__filename__ = 'components/single-tree-selector.js'
